/* Terminología de la tienda. Cubre también descripciones y contenido
   procedentes de Shopify, sin alterar URLs, código ni campos editables. */
(function () {
  'use strict';
  var raiz = document.getElementById('root');
  if (!raiz) { return; }
  var excluidos = 'script,style,noscript,textarea,input,code,pre,[contenteditable]';
  var atributos = ['alt', 'title', 'aria-label', 'placeholder'];
  var selectorAtributos = '[alt],[title],[aria-label],[placeholder]';
  var pendientes = new Set();
  var programado = false;
  var rapido = /esencia/i; // filtro barato: casi ningun texto contiene la palabra

  function normalizar(texto) {
    return texto.replace(/(^|[^\p{L}\p{N}_])(esencias?)(?=$|[^\p{L}\p{N}_])/giu, function (_, inicio, palabra) {
      var cambio = palabra.toLowerCase().endsWith('s') ? 'fragancias' : 'fragancia';
      if (palabra === palabra.toUpperCase()) { cambio = cambio.toUpperCase(); }
      else if (palabra[0] === palabra[0].toUpperCase()) {
        cambio = cambio[0].toUpperCase() + cambio.slice(1);
      }
      return inicio + cambio;
    });
  }

  function texto(nodo) {
    if (!nodo.nodeValue || !rapido.test(nodo.nodeValue)) { return; }
    if (!nodo.parentElement || nodo.parentElement.closest(excluidos)) { return; }
    var nuevo = normalizar(nodo.nodeValue);
    if (nuevo !== nodo.nodeValue) { nodo.nodeValue = nuevo; }
  }

  function etiquetas(elemento) {
    if (!atributos.some(function (a) { var v = elemento.getAttribute(a); return v && rapido.test(v); })) { return; }
    if (elemento.closest('script,style,noscript,code,pre,[contenteditable]')) { return; }
    atributos.forEach(function (atributo) {
      var actual = elemento.getAttribute(atributo);
      if (!actual) { return; }
      var nuevo = normalizar(actual);
      if (nuevo !== actual) { elemento.setAttribute(atributo, nuevo); }
    });
  }

  function revisar(nodo) {
    if (nodo.nodeType === 3) { texto(nodo); return; }
    if (nodo.nodeType !== 1) { return; }
    etiquetas(nodo);
    if (nodo.closest(excluidos)) { return; }
    var recorrido = document.createTreeWalker(nodo, NodeFilter.SHOW_TEXT);
    var siguiente;
    while ((siguiente = recorrido.nextNode())) { texto(siguiente); }
    nodo.querySelectorAll(selectorAtributos).forEach(etiquetas);
  }

  revisar(raiz);
  document.title = normalizar(document.title);
  document.querySelectorAll('meta[name="description"],meta[property="og:title"],meta[property="og:description"],meta[name="twitter:title"],meta[name="twitter:description"]').forEach(function (meta) {
    var actual = meta.getAttribute('content');
    if (actual) { meta.setAttribute('content', normalizar(actual)); }
  });

  /* Sólo se revisan los nodos que cambian: filtros, buscador, carruseles
     y secciones recargadas por el editor, no toda la página en cada cambio. */
  new MutationObserver(function (cambios) {
    cambios.forEach(function (cambio) {
      if (cambio.type === 'childList') { cambio.addedNodes.forEach(function (nodo) { pendientes.add(nodo); }); }
      else { pendientes.add(cambio.target); }
    });
    if (programado) { return; }
    programado = true;
    requestAnimationFrame(function () {
      programado = false;
      pendientes.forEach(function (nodo) { if (raiz.contains(nodo)) { revisar(nodo); } });
      pendientes.clear();
    });
  }).observe(raiz, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: atributos});
})();
